module.exports = __webpack_public_path__ + "img/shape.1fa38d7e.svg";